export default "__VITE_ASSET__pchYlX0d__"